import React from 'react';
import EditSelectedImageVideoUploadSlider from './EditSelectedImageVideoUploadSlider';

export default function EditListingSpaceImageVideoUpload({
    spaceId,
    formData,
    setFormData,
    selectedImageVideoPreviews,
    setSelectedImageVideoPreviews,
    removeMedia,
    setRemoveMedia,
    isDisabledEverything
}) {
    const handleSelectFile = (e) => {
        // now adding new selected files
        const selectedFiles = e.target.files;

        const selectedFilesArray = Array.from(selectedFiles);

        // now adding files
        if (selectedFilesArray.length === 0) return;
        setFormData((prev) => ({
            ...prev,
            spaceMedia: prev.spaceMedia ? [...prev.spaceMedia, ...selectedFilesArray] : [...selectedFilesArray]
        }));
        const filesArray = selectedFilesArray.map((file) => {
            return {
                blobUrl: URL.createObjectURL(file),
                size: file.size,
                type: file.type,
                name: file.name
            };
        });
        // const filesLength = filesArray.length + selectedImageVideoPreviews.length;
        setSelectedImageVideoPreviews((prev) => [...prev, ...filesArray]);
        // setSelectedImageVideoPreviewsLength(filesLength);
    };

    return (
        <div className="col-12">
            <div className="c-uploadimage">
                <h6 className="c-uploadimage-label">Upload Image/Video</h6>
                <span className="messageInfo">PNG,JPG, GIF, AVI, MP4 Files are accepted</span>
                <div className="c-uploadimage-wrap">
                    <label htmlFor="upload-img" className="c-uploadimage-btn">
                        Browse to choose the file here
                        <input
                            type="file"
                            className="file-upload"
                            id="upload-img"
                            multiple
                            accept=".png,.jpg,.jpeg,.gif,.avi,.mp4"
                            onChange={handleSelectFile}
                            disabled={isDisabledEverything}
                        />
                        <span className="c-uploadimage-text">
                            Maximum file size should not be more than <strong>&nbsp;20MB</strong>
                        </span>
                    </label>
                    {selectedImageVideoPreviews.length > 0 && (
                        <EditSelectedImageVideoUploadSlider
                            spaceId={spaceId}
                            selectedImageVideoPreviews={selectedImageVideoPreviews}
                            setSelectedImageVideoPreviews={setSelectedImageVideoPreviews}
                            formData={formData}
                            setFormData={setFormData}
                            removeMedia={removeMedia}
                            setRemoveMedia={setRemoveMedia}
                            isDisabledEverything={isDisabledEverything}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}
